// @noflow
import { cloneElement, Component } from 'react';

import PropTypes from 'prop-types';

export default class DelayCSS extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        cssClassesToAdd: PropTypes.string.isRequired,
        durationMs: PropTypes.number
    };

    static defaultProps = {
        durationMs: 0
    };

    constructor(props) {
        super(props);

        this.state = {
            isWaitOver: false
        };

        setTimeout(() => {
            this.setState({ isWaitOver: true });
        }, props.durationMs);
    }

    render() {
        const { children: { props: { className } }, cssClassesToAdd } = this.props;
        const { isWaitOver } = this.state;

        return cloneElement(
            this.props.children,
            isWaitOver ? { className: `${className || ''} ${cssClassesToAdd}` } : {}
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/delay-css/index.js